import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
// keen
import 'assets/styles/keen/theme01/plugins.bundle.css';
import 'assets/styles/keen/theme01/style.bundle.css';
// app custom style
import 'assets/styles/app.style.scss';
import 'assets/styles/custom.style.scss';
import './index.css';
// i18
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18n';
// redux
import { Provider } from 'react-redux';
import store from 'app/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
  // </React.StrictMode>
);

// Register service worker
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
